//Links constant
// export const DASHBOARD_LINK = '/editor/';
// export const EDITOR_LINK = '/editor/';
// export const HEADING_LINK = '/editor/details/';
export const DASHBOARD_LINK = '';
export const EDITOR_LINK = '/editor/';
export const EDITOR_ALL_INONE_LINK = '/editor/allinone/';
export const HEADING_LINK = '/editor/details/';
export const WORKHISTORY_LINK = '/editor/work-history/';
export const EDUCATION_LINK = '/editor/education/';
export const SKILLS_LINK = '/editor/skills/';
export const SUMMARY_LINK = '/editor/summary/';
export const FINALIZE_LINK = '/editor/finalize/';
export const ACCOMPLISHMENTS_LINK = '/editor/accomplishments/'
export const AFFILIATIONS_LINK = '/editor/affiliations/'
export const ADDITIONAL_INFO_LINK = '/editor/additional-information/'
export const ADDITIONAL_SECTIONS_LINK = '/editor/additional-sections/'
export const SOFTWARE_LINK = '/editor/software/'
export const LANGUAGE_LINK = '/editor/languages/'
export const REFERENCE_LINK = '/editor/references/'
export const CERTIFICATIONS_LINK = '/editor/certifications/'
export const INTERESTS_LINK = '/editor/interests/'
export const FINAL_RESUME = '/templates/'
export const RESUMES_LINK = '/editor/resumes/'
export const REARRANGE_LINK = '/editor/rearrange/'
export const RESUME_LINK = '/rlink/:id'
export const LOGIN_LINK = '/login/';
export const LOGIN_PROGRESS_LINK = '/login-progress/';
export const LOGOUT_LINK = '/logout/';
export const SIGNUP_LINK = '/signup/';
export const FORGET_LINK = '/forget-password/';
export const FORGOT_LINK = '/forgot-password/';
export const RESET_LINK = '/resetpswd/';
export const RESET_PASSWORD = '/reset-password/';
export const CHOOSE_COLOR = '/choose-template/';
export const CUSTOM_SECTION_LINK = '/editor/customsection/'
export const VOLUNTEER_INFO_LINK = '/editor/volunteer/'
export const WORKHISTORY_TIPS_LINK = '/editor/work-history-tips/'
export const EDUCATION_TIPS_LINK = '/editor/education-tips/'
export const SKILL_TIPS_LINK = '/editor/skill-tips/'
export const SUMMARY_TIPS_LINK = '/editor/summary-tips/'
export const EDITOR_PAGES = [ADDITIONAL_SECTIONS_LINK, EDITOR_ALL_INONE_LINK, WORKHISTORY_LINK, EDUCATION_LINK, SKILLS_LINK, SUMMARY_LINK, FINALIZE_LINK, ACCOMPLISHMENTS_LINK, ADDITIONAL_INFO_LINK, SOFTWARE_LINK, LANGUAGE_LINK, CERTIFICATIONS_LINK, INTERESTS_LINK, FINAL_RESUME, AFFILIATIONS_LINK, CUSTOM_SECTION_LINK, HEADING_LINK, VOLUNTEER_INFO_LINK, REARRANGE_LINK,WORKHISTORY_TIPS_LINK, SUMMARY_TIPS_LINK, SKILL_TIPS_LINK, EDUCATION_TIPS_LINK]
export const CREATE_RESUME = '/create-resume/';
export const UPLOAD_RESUME = '/upload-resume/';
export const CHOOSE_EDITOR = '/choose-editor/';
export const CREATE_RESUME_WITH_AI = '/create-resume-with-ai/';
export const MEMBERSHIP = '/membership/';
export const CHECKOUT = '/checkout/';
export const MY_ACCOUNT = '/my-account/';
export const MEMBERSHIP_CANCELLATION = '/membership/cancellation/'
export const EDIT_PROFILE = '/edit-profile/';
export const CHANGE_PASSWORD = '/change-password/';
export const UPDATE_PAYMENT_INFO = '/update-payment-info/';
export const INVOICES = '/invoices/';
export const PAYMENT_METHODS = '/payment-methods/';
export const COVERLETTER_LINK = '/build-cover-letter/';
export const BUILD_COVERLETTER = '/build-coverletter/';
export const COVERLETTER_CHOOSE_TEMPLATE = '/build-cover-letter/choose-template/';
export const COVERLETTER_CUSTOMIZE = '/build-cover-letter/customize/';
export const COVERLETTER_JOBDETAILS = '/build-cover-letter/job-details/';
export const COVERLETTER_STRENGTH = '/build-cover-letter/strengths/';
export const COVERLETTER_SKILLS = '/build-cover-letter/skills/';
export const COVERLETTER_EXPERIENCE = '/build-cover-letter/experience/';
export const COVERLETTER_EXP_WORKHISTORY = '/build-cover-letter/experience/work-history/';
export const COVERLETTER_WORKSTYLE = '/build-cover-letter/work-style/';
export const COVERLETTER_FINALIZE = '/build-cover-letter/finalize/';
export const COVERLETTER_PERSONALIZE = '/build-cover-letter/personalize/';
export const COVERLETTER_LOGIN = '/build-cover-letter/sign-up/';
export const COVERLETTER_SHARE_LINK = '/cl/:id'
export const COVERLETTER_SHAREPDF_LINK = '/cl-link/:id'
export const COVERLETTER_LANDINGPAGE = '/build-cover-letter/'
export const REFRESH_LINK = '/refresh/';
// export const QUICK_EDITOR = '/quick-editor/' // Disabled - using ALLINONE editor instead
export const QUICK_EDITOR = EDITOR_ALL_INONE_LINK; // '/editor/allinone/'

export const COVERLETTER_PAGES = [COVERLETTER_CHOOSE_TEMPLATE,COVERLETTER_CUSTOMIZE, COVERLETTER_JOBDETAILS,COVERLETTER_STRENGTH,COVERLETTER_SKILLS,COVERLETTER_EXPERIENCE,COVERLETTER_EXP_WORKHISTORY,COVERLETTER_WORKSTYLE,COVERLETTER_FINALIZE,COVERLETTER_PERSONALIZE,]
export const COVERLETTER_QA_PAGES = [ COVERLETTER_JOBDETAILS,COVERLETTER_STRENGTH,COVERLETTER_SKILLS,COVERLETTER_EXP_WORKHISTORY,COVERLETTER_WORKSTYLE]
export const NEXT_WORKHISTORY_LABEL = 'Continue';
export const NEXT_EDUCATION_LABEL = 'Continue';
export const NEXT_SKILLS_LABEL = 'Continue';
export const NEXT_SUMMARY_LABEL = 'Continue';
export const NEXT_FINALIZE_LABEL = 'Continue';
export const NEXT_LABEL = 'Continue';
export const MY_DASHBOARD_LINK = '/membership-account/';
export const RECAPTCHA_SITE_KEY = '6LfyXOwpAAAAAHk8S20rPSPNWMj4IJLnYXsolrT8';
export const UNDO_LIMIT = 100;
export const REDO_LIMIT = 100;
export const PAID_SERVICES = true;
export const ACCOUNT_SYNC = 900; // in seconds
export const COUPON_SERVICES = false;
export const CRYPTO_SECRET_KEY = '#`)R$+,ap5?16`<11Q(bk,RzBc71XsE:yL8^|ky`P XpAw<h(puEBR@J^6^J&^(7R'

export const HOME_URL = CUSTOM_HOME_URL;
export const APP_DOMAIN = APP_URL;
export const SITE_DOMAIN = SITE_URL;
export const COOKIE_DOMAIN = RB_COOKIE_DOMAIN;
export const SENTRY_REPO_URL = RB_SENTRY_REPO_URL;
export const SEARCH_PARAMS = RB_SEARCH_PARAMS;

export const REVIEW_LANDINGPAGE_LINK = '/review/'
export const REVIEW_HEADING_LINK = '/review/details/';
export const REVIEW_WORKHISTORY_LINK = '/review/work-history/';
export const REVIEW_EDUCATION_LINK = '/review/education/';
export const REVIEW_SKILLS_LINK = '/review/skills/';
export const REVIEW_SUMMARY_LINK = '/review/summary/';
export const REVIEW_ADDITIONAL_SECTIONS_LINK = '/review/additional-sections/'

export const IMAGE_FOLDER_URL = `${SITE_DOMAIN}/wp-content/themes/resumebuilder/builder/src/assets/images`;
export const APP_IMAGE_FOLDER_URL = `${APP_DOMAIN}/assets/images`;
export const ADDITONAL_PREDEFINE_SECTIONS = {
  additional_information: { struct: { content: '', new: true,
  grid: {
    row_1: {name:'', address: '',address_line_2:'', start_date:'',end_date:'',content:'', url:'', open:true },
  }, }, name: 'Custom Section' },
  accomplishments: { name: 'Accomplishments', url: ACCOMPLISHMENTS_LINK, struct: { 
    content: '', 
    new: true,
    grid: {
      row_1: { award_name: '', awarded_by: '', awarded_date:'',content:'',open:true },
    }, } },
  affiliations: { name: 'Affiliations', url: AFFILIATIONS_LINK, struct: { content: '', new: true } },
  volunteer: { name: 'Volunteering', url: VOLUNTEER_INFO_LINK, struct: { 
    content: '', 
    new: true,
    grid: {
      row_1: { activity_name: '', address: '',address_line_2:'', start_date:'',end_date:'',content:'',open:true },
    },
  } },
  certifications: {
    name: 'Certifications', url: CERTIFICATIONS_LINK, struct: {
      set: {
        row_1: { date: '', name: '',institution:'' ,content:'', url:'', open:true  },
      }, new: true,
    }
  },
  languages: { name: 'Languages', url: LANGUAGE_LINK, struct: { 
    content: '', 
    new: true,
    grid: {
      row_1: { expertise_level: 5, name: '',open:true },
    },
   } },
  //references: { name: 'References', url: REFERENCE_LINK, struct: { content: '', new: true } },
  references: {
    name: 'References', 
    url: REFERENCE_LINK, 
    struct: {
      grid: {
        row_1: { name: '', reference_reletionship: '', start_date: '', end_date: '', content: '', open: true },
      }, 
      new: true,
    }
  },
  interests: { name: 'Interests', url: INTERESTS_LINK, struct: { content: '', new: true } },
  softwares: { name: 'Software', url: SOFTWARE_LINK, struct: { 
    content: '', 
    new: true,
    grid: {
      row_1: { expertise_level: 5, name: '',open:true },
    },
   }  },
}
export const TPLS_COLOR = [
  { id: 'color-variant-one', name: 'Purple', color_code: '#7D7D7D' },
  { id: 'color-variant-two', name: 'Blue', color_code: '#00008B' },
  { id: 'color-variant-three', name: 'Orange', color_code: '#8C0000' },
  { id: 'color-variant-four', name: 'Green', color_code: '#005000' },
  // { id: 'color-dark-grey-variant', name: 'Grey' },
  { id: 'color-variant-five', name: 'Dark Pink', color_code: '#17A9E4' },
  { id: 'color-variant-six', name: 'Light Green', color_code: '#FF7F7F' },
  { id: 'color-variant-seven', name: 'Light Pink', color_code: '#22A699' },
  { id: 'color-variant-eight', name: 'Navy Blue', color_code: '#FFCC00' },
  { id: 'color-variant-nine', name: 'Off White', color_code: '#f5f1ee' },
];
export const OLD_COLOR_CODES = {
  'color-variant-orange' : 'color-variant-one',
  'color-variant-blue' : 'color-variant-two',
  'color-variant-pink' : 'color-variant-three',
  'color-dark-grey-variant' : 'color-variant-four',
  'color-variant-green' : 'color-variant-five',
  'color-variant-purple' : 'color-variant-six',
  'color-variant-pink-two' : 'color-variant-seven',
  'color-variant-green-two' : 'color-variant-eight',
  'color-navy-blue-variant' : 'color-variant-nine'
}

// Backward compatibility map for old template names
// Maps old template IDs to new template IDs for resumes created before template renaming
export const TEMPLATE_BACKWARD_COMPATIBILITY_MAP = {
  'template-four-v3': 'template-four-v2',
  'template-three-v3': 'template-three',
  'template-one-v2': 'template-two-v2',
  'template-four': 'template-twenty-five',
  'template-five-v4': 'template-two-v3',
  'template-one-v3': 'template-seven-v2',
  'template-two': 'template-two-v2',
  'template-nine': 'template-nine-v2',
};

export const TPLTS = [
  // Row 1
  // { id: "template-thirty-one", name: "Template Thirty One", color: 'color-variant-thirty-one', resume: true, resume_listing_priority: 100, profile_picture: true },
  // { id: "template-thirty-two", name: "Template Thirty Two", color: 'color-variant-thirty-two-2', resume: true, resume_listing_priority: 100, profile_picture: true },
  // { id: "template-thirty-three", name: "Template Thirty Three", color: 'color-variant-thirty-three-3', resume: true, resume_listing_priority: 100, profile_picture: true },
  // { id: "template-thirty-four", name: "Template Thirty Four", color: 'color-variant-thirty-four-4', resume: true, resume_listing_priority: 100, profile_picture: true },
  // { id: "template-thirty-five", name: "Template Thirty Five", color: 'color-variant-thirty-five-5', resume: true, resume_listing_priority: 100, profile_picture: true },
  // { id: "template-thirty-six", name: "Template Thirty Six", color: 'color-variant-thirty-six-6', resume: true, resume_listing_priority: 100, profile_picture: true },
  // { id: "template-thirty-seven", name: "Template Thirty Seven", color: 'color-variant-thirty-seven-7', resume: true, resume_listing_priority: 100, profile_picture: false },
  // { id: "template-thirty-eight", name: "Template Thirty Eight", color: 'color-variant-thirty-eight-8', resume: true, resume_listing_priority: 100, profile_picture: false },
  // { id: "template-thirty-nine", name: "Template Thirty Nine", color: 'color-variant-thirty-nine-9', resume: true, resume_listing_priority: 100, profile_picture: false },

  { id: "template-nineteen", name: "Template Nineteen", color: 'color-variant-forty-one', resume: true, resume_listing_priority:100 , coverletter: true, coverletter_listing_priority:304  , profile_picture: true }, // order: 2
  { id: "template-twenty-four", name: "Template Twenty Four", color: 'color-variant-thirty-two', coverletter: true,coverletter_listing_priority: 313, resume: true, resume_listing_priority:100, profile_picture: true }, // order: 2
  // { id: "template-twenty-three-v2", name: "Template Twenty Three V2", color: 'color-variant-twenty-three', resume: false, resume_listing_priority:100 , coverletter: true, coverletter_listing_priority: 307  , profile_picture: true }, // order: 2
  { id: "template-two-v3", name: "Template Two V3", color: 'color-variant-sixty-three', resume: true, resume_listing_priority:100 , profile_picture: false }, // order: 3
  { id: "template-thirteen", name: "Template Thirteen", color: 'color-variant-sixty-six', resume: true, resume_listing_priority:100, coverletter: true, coverletter_listing_priority: 310  , profile_picture: false }, // order: 2

  // Row 2
  { id: "template-one", name: "Template One", color: 'color-variant-thirty-six', resume: true, resume_listing_priority:100 , profile_picture: true },
  { id: "template-ten-v4", name: "Template Ten V4", color: 'color-variant-seventy-four', resume: true, resume_listing_priority:100 , profile_picture: false },
  //{ id: "template-two", name: "Template Two", color: 'color-variant-two', resume: true, resume_listing_priority:100 , profile_picture: true },

  // Row 3
  { id: "template-twenty", name: "Template Twenty", color: 'color-variant-forty-two', resume: true, resume_listing_priority:100 , profile_picture: true }, // order: 2
  // { id: "template-eleven", name: "Template Eleven", color: 'color-variant-five' , profile_picture: true }, // updated order: 1
  // { id: "template-ten", name: "Template Ten", color: 'color-variant-ten' , profile_picture: true },
  // { id: "template-thirteen", name: "Template Thirteen", color: 'color-variant-twelve' , profile_picture: true }, // order: 2
  // { id: "template-fourteen", name: "Template Fourteen", color: 'color-variant-six' , profile_picture: true }, // order: 2
  // { id: "template-fifteen", name: "Template Fifteen", color: 'color-variant-ten' , profile_picture: true }, // order: 2
  // { id: "template-sixteen", name: "Template Sixteen", color: 'color-variant-five' , profile_picture: true }, // order: 2
  // { id: "template-seventeen", name: "Template Seventeen", color: 'color-variant-eleven' , profile_picture: true }, // order: 2
  // { id: "template-eighteen", name: "Template Eighteen", color: 'color-variant-twelve' , profile_picture: true }, // order: 2
  // { id: "template-nineteen", name: "Template Nineteen", color: 'color-variant-seven' , profile_picture: true }, // order: 2
  // { id: "template-twenty", name: "Template Twenty", color: 'color-variant-ten' , profile_picture: true }, // order: 2
  { id: "template-twenty-five", name: "Template Twenty Five", color: 'color-variant-sixty-five', resume: true, resume_listing_priority:100  , profile_picture: false }, // order: 2
  //{ id: "template-twenty-one", name: "Template Twenty One", color: 'color-variant-fifteen' , profile_picture: true }, // order: 2
  { id: "template-twenty-three", name: "Template Twenty Three", color: 'color-variant-forty-three', resume: true, resume_listing_priority:100,  coverletter: true, coverletter_listing_priority: 200  , profile_picture: true }, // order: 2
  { id: "template-eighteen", name: "Template Eighteen", color: 'color-variant-thirty-seven', resume: true, resume_listing_priority:100 , coverletter: true, coverletter_listing_priority: 305  , profile_picture: true }, // order: 2
  
  // Row 4
  //{ id: "template-four", name: "Template Four", color: 'color-variant-four', resume: true, resume_listing_priority:100 , profile_picture: false }, // order: 4
  { id: "template-four-v4", name: "Template Four V4", color: 'color-variant-forty-seven', resume: true, resume_listing_priority:100, profile_picture: false },
  { id: "template-four-v5", name: "Template Four V5", color: 'color-variant-fifty-five', resume: true, resume_listing_priority:100, profile_picture: false },
  { id: "template-ten-v5", name: "Template Ten V5", color: 'color-variant-seventy-three', resume: true, resume_listing_priority:100 , profile_picture: false },
  { id: "template-ten-v2", name: "Template Ten V2", color: 'color-variant-seventy-seven', resume: true, resume_listing_priority:100, profile_picture: false },
  { id: "template-five", name: "Template Five", color: 'color-variant-sixty-seven', resume: true, resume_listing_priority:100 , profile_picture: false }, //order: 6
  
  // Row 5
  { id: "template-fifteen", name: "Template Fifteen", color: 'color-variant-seventy', resume: true, resume_listing_priority:100, profile_picture: false }, // order: 2
  { id: "template-eleven", name: "Template Eleven", color: 'color-variant-sixty-eight', coverletter: true, coverletter_listing_priority: 312, resume: true, resume_listing_priority:100 , profile_picture: false }, // updated order: 1
  { id: "template-twelve", name: "Template Twelve", color: 'color-variant-sixty', coverletter: true, coverletter_listing_priority: 311, resume: true, resume_listing_priority:100  , profile_picture: false }, // order: 2
  { id: "template-ten", name: "Template Ten", color: 'color-variant-sixty-two', resume: true, resume_listing_priority:100, profile_picture: false },
  
  // Row 6
  { id: "template-six", name: "Template six", color: 'color-variant-forty-four', resume: true, resume_listing_priority:100 , profile_picture: false }, //order: 7
  { id: "template-seven-v3", name: "Template Seven V3", color: 'color-variant-thirty-three', resume: true, resume_listing_priority:100 , profile_picture: true }, //order: 10
  { id: "template-six-v3", name: "Template six V3", color: 'color-variant-thirty-four', resume: true, resume_listing_priority:100 , profile_picture: true }, //order: 8
  { id: "template-six-v2", name: "Template Six V2", color: 'color-variant-seventy-five', resume: true, resume_listing_priority:100, profile_picture: false },
  { id: "template-eight-v2", name: "Template Eight V2", color: 'color-variant-thirty-eight', resume: true, resume_listing_priority:100 , profile_picture: true }, //order:11
  
  // Row 7
  { id: "template-seven", name: "Template Seven", color: 'color-variant-sixty-nine', resume: true, resume_listing_priority:100 , profile_picture: false }, //order: 9
  { id: "template-fourteen", name: "Template Fourteen", color: 'color-variant-fifty-six', resume: true, resume_listing_priority:100, coverletter: true, coverletter_listing_priority: 309  , profile_picture: false }, // order: 2
  { id: "template-sixteen", name: "Template Sixteen", color: 'color-variant-thirty-one', resume: true, resume_listing_priority:100, coverletter: true, coverletter_listing_priority: 308  , profile_picture: true }, // order: 2
  // { id: "template-sixteen-v2", name: "Template Sixteen V2", color: 'color-variant-five', resume: false, resume_listing_priority:100 , coverletter: true, coverletter_listing_priority: 201  , profile_picture: true }, // order: 2
  { id: "template-seventeen", name: "Template Seventeen", color: 'color-variant-forty-eight', resume: true, resume_listing_priority:100 , coverletter: true, coverletter_listing_priority: 306   , profile_picture: true }, // order: 2
  
  // Row 8
  { id: "template-two-v2", name: "Template Two V2", color: 'color-variant-fifty-seven', resume: true, resume_listing_priority:100 , profile_picture: true },
  { id: "template-three", name: "Template Three", color: 'color-variant-forty', resume: true, resume_listing_priority:100 , profile_picture: true },
  { id: "template-three-v2", name: "Template Three V2", color: 'color-variant-forty-nine', resume: true, resume_listing_priority:100, profile_picture: false },
  { id: "template-three-v4", name: "Template Three V4", color: 'color-variant-fifty-two', resume: true, resume_listing_priority:100, profile_picture: false },
  { id: "template-three-v5", name: "Template Three V5", color: 'color-variant-sixty-four', resume: true, resume_listing_priority:100, profile_picture: false },
  { id: "template-four-v2", name: "Template Four V2", color: 'color-variant-fifty', resume: true, resume_listing_priority:100 , profile_picture: true },

  // Row 9

  // Row 10
  { id: "template-five-v3", name: "Template Five V3", color: 'color-variant-thirty-nine', resume: true, resume_listing_priority:100 , profile_picture: true },
  { id: "template-eight-v3", name: "Template Eight V3", color: 'color-variant-sixty-one' , resume: true, resume_listing_priority:100, profile_picture: false },
  { id: "template-nine-v2", name: "Template Nine V2", color: 'color-variant-fifty-four' , resume: true, resume_listing_priority:100, profile_picture: true },

  // Row 11
  { id: "template-five-v2", name: "Template Five V2", color: 'color-variant-fifty-eight' , resume: true, resume_listing_priority:100, profile_picture: false },
  { id: "template-five-v5", name: "Template Five V5", color: 'color-variant-forty-five', resume: true, resume_listing_priority:100, profile_picture: false },

  // Row 12
  { id: "template-ten-v3", name: "Template Ten V3", color: 'color-variant-seventy-one', resume: true, resume_listing_priority:100 , profile_picture: false },
  { id: "template-nine-v3", name: "Template Nine V3", color: 'color-variant-fifty-nine', resume: true, resume_listing_priority:100 , profile_picture: false },
  { id: "template-eight", name: "Template Eight", color: 'color-variant-thirty-five', resume: true, resume_listing_priority:100 , profile_picture: true },

  // Row 13
  { id: "template-seven-v2", name: "Template Seven V2", color: 'color-variant-forty-six', resume: true, resume_listing_priority:100 , profile_picture: true },
 // { id: "template-nine", name: "Template Nine", color: 'color-variant-nine', resume: true, resume_listing_priority:100 , profile_picture: true },
  
]
export const BREADCRUMB_LINKS = {
  heading: {
    id: "heading",
    tab_name: "Contact Information",
    link: HEADING_LINK,
    main_title: "What’s the best way for employers to contact you?",
    description: "Include your email and phone number.",
    tooltip: "'Heading Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',"
  },
  education: {
    id: "education",
    tab_name: "Education",
    link: EDUCATION_LINK,
    main_title: "Tell us about your education",
    description: "Include every school, even if you're still there or didn't graduate.",
    tipspage_heading: "Great job! Up next, your educational milestones.",
    tooltip: "'educaiton Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
  },
  work_history: {
    id: "work_history",
    tab_name: "Work Experience",
    link: WORKHISTORY_LINK,
    tipspage_heading: "Looking good! Let’s tackle your professional experience.",
    tooltip: "'WORKHISTORY Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
    wh_1: {
      id: "work_history_1",
      tab_name: "Work Experience",
      main_title: "Tell us about your most recent job",
      description: "We’ll start there and work backward.",
    },
    wh_2: {
      id: "work_history_2",
      tab_name: "Work Experience",
      main_title: "What did you do at ABCDE Company as a Sale Associate",
      description:
        "Get help writing your bullet points with the pre-written examples below.",
      predefind_list: [
        {
          title: "Expert Recommendation",
          description:
            "Helped customers locate products and checked store system for merchandise at other sites.",
        },
        {
          title: "Expert Recommendation 2",
          description:
            "Organized racks and shelves to maintain store visual appeal, engage customers and promote specific merchandise.",
        },
        {
          title: "Expert Recommendation 3",
          description:
            "Loaded and unloaded merchandise using ladder and pallet jack.",
        },
      ],
    },
  },
  skills: {
    id: "skills",
    tab_name: "Key Skills",
    link: SKILLS_LINK,
    main_title: "What skills do you want to highlight?",
    description: "Use our expert recommendations below to get started.",
    tipspage_heading: "Excellent progress! Now, let’s highlight your key skills.",
    tooltip: "'skills Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
    data: {
      descr: "",
    },
    predefined_list: [
      {
        title: "Microsoft Word",
      },
      {
        title: "Photoshop",
      },
      {
        title: "Illustrator",
      },
      {
        title: "In Design",
      },
    ],
  },
  summary: {
    id: "summary",
    tab_name: "Profile",
    link: SUMMARY_LINK,
    main_title: "Briefly tell us about your background",
    description: "Use our expert recommendations below to get started.",
    tipspage_heading: "Almost done! Let’s bring it all together with your summary.",
    tooltip: "'Summary Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
    data: {
      content: "",
    },
    predefined_list: [
      {
        title: "Microsoft Word",
        desc:
          "Highly motivated Sales Associate with extensive customer service and sales experience. Outgoing sales professional with track record of driving increased sales, improving buying experience and elevating company profile with target market. Consistently recognized for sales performance and excellence in customer service.",
      },
      {
        title: "Photoshop",
        desc:
          "Highly motivated Sales Associate with extensive customer service and 1",
      },
      {
        title: "Illustrator",
        desc:
          "Highly motivated Sales Associate with extensive customer service and 2",
      },
      {
        title: "In Design",
        desc:
          "Highly motivated Sales Associate with extensive customer service and  3",
      },
    ],
  },
  finalize: {
    id: "finalize",
    tab_name: "Complete",
    link: FINALIZE_LINK,
    main_title: "The Preview of the Resume",
    description: "The completed resume will be look like as the preview",
    tooltip: "'finalize Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
  },
  additional_sections: {
    id: "additional_sections",
    tab_name: "Aditional Sections",
    link: ADDITIONAL_SECTIONS_LINK,
  },
}
export const DEGREES = [
  'High school diploma',
  'GED',
  'Associate of Art',
  'Associate of Science',
  'Bachelor of Art',
  'Bachelor of Science',
  'BBA',
  'Master of Arts',
  'Master of Science',
  'MBA',
  'MD',
  'JD',
  'Ph.D'
]
export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const START_YEAR = 1920;

export const STATE_LIST = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'Washington D.C.', 'West Virginia', 'Wisconsin', 'Wyoming'];

export const DEFAULT_SECTION_DISPLAY_ORDER = ['work_history', 'education_history', 'skills'];

export const DEFAULT_SECTION_NAMES = {
  'work_history': 'Add Your Professional Experience', 'education_history': 'Add Your Education', 'skills': 'List Your Key Skills',
  ...(() => {
    let name = {}
    Object.keys(ADDITONAL_PREDEFINE_SECTIONS).forEach((v) => {
      name = { ...name, [v]: ADDITONAL_PREDEFINE_SECTIONS[v].name }
    })
    return name
  })()
}

export const FONT_FAMILIES = [
  { id: '', name: 'Default' },
  { id: 'merriweather', name: 'Merriweather' },
  { id: 'montserrat', name: 'Montserrat' },
  { id: 'raleway', name: 'Raleway' },
  { id: 'roboto', name: 'Roboto' },
  { id: 'ubuntu', name: 'Ubuntu' }
]

export const FONT_SIZES = [
  // { id: '', name: 'Default' },
  { id: 'small', name: 'Small' },
  { id: 'medium', name: 'Medium' },
  { id: 'large', name: 'Large' },
  { id: 'extra-large', name: 'Extra Large' }
]

export const LINE_SPACING = [
  // { id: '', name: 'Default' },
  { id: 'small', name: 'Small' },
  { id: 'medium', name: 'Medium' },
  { id: 'large', name: 'Large' },
  { id: 'extra-large', name: 'Extra Large' }
]

export const HELP_OPTIONS = [
  // { id: 1, name: 'Billing' },
  { id: 2, name: 'Accessing my account' },
  { id: 3, name: 'Technical Assistance' },
  { id: 4, name: 'Other' }
]

export const REACT_APP_SECRET_KEY = "6Lf6ksMUAAAAABT-wJcNnEtK7qcYuOIIN5N9Htyo";
export const REACT_APP_SITE_KEY = "6Lf6ksMUAAAAAKh-PUMPIJlJXC1jQewOjh_D5ES0";

export const SOCIAL_LOGIN_GG_CLIENT_ID = '408941295968-9nbmcj2cg5rq54je0veopec9b137udgl.apps.googleusercontent.com';
export const SOCIAL_LOGIN_GG_CLIENT_SECRET = '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';
export const SOCIAL_LOGIN_FB_APP_ID = 1584485932059949;

export const FULLSTORY_ORG_ID = 'o-1NBGEW-na1';

export const STRIPE_PUBLISHABLE_KEY = RB_STRIPE_PUBLISHABLE_KEY;

export const FACEBOOK_META_PIXEL_ID = RB_FACEBOOK_META_PIXEL_ID;

export const REDIRECT_URI = `${APP_URL}/login`;

export const SKILL_LEVEL = ['Beginner', 'Amateur', 'Competent', 'Proficient', 'Expert'];
export const SKIP_CONFIRMATION_BOX_CONTENT = {
  heading: `Are you sure about skipping?`,
  content: "We recommend filling in every section. If you skip it, it won’t appear on your resume. You can, however, fill it out later if you would like.",
  confirmButtonText: 'Skip',
  cancelButtonText: "I don't want to skip"
}
export const SHOW_PROFILE_PICTURE_CONFIRMATION_BOX_CONTENT = {
  heading: `Would you like to disable the profile picture?`,
  content: "If you disable the profile picture, it won't appear on your resume.",
  confirmButtonText: 'Disable',
  cancelButtonText: "I don't want to disable"
}
export const DELETE_CONFIRMATION_BOX_CONTENT = {
  heading: `Confirm`,
  content: "Would you like to delete this summary?",
  confirmButtonText: "Yes",
  cancelButtonText: 'No'
}
export const POPUP_TYPES = {
  section_skip: {
      type: 'confirmbox',
      content: SKIP_CONFIRMATION_BOX_CONTENT,
  },
  row_delete: {
      type: 'confirmbox',
      content: DELETE_CONFIRMATION_BOX_CONTENT,
  },
  delete: {
      type: 'confirmbox',
      content: {
        heading: `Confirm`,
        content: "Are you sure you want to delete?",
        confirmButtonText: "Yes",
        cancelButtonText: 'No'
      }
  },
  share: {
    type: 'sharebox',
    content: {
      title: `Share`,
      heading: `Share a Link to Your Resume`,
      // content: [
      //   "Share this link on social media or copy and paste the URL to send your resume via text, email or to share your resume on your personal website.",
      //   "Copy this private URL"
      // ],
      content: 
        "Share this link on social media or copy and paste the URL to send your resume via text, email or to share your resume on your personal website."
        +" Copy this private URL"
      ,
      copyButtonText: "Copy Link",
      openLinkText: 'Open Link'
    }
  },
  msgbox1: {
    type: 'confirmbox',
    content: {
      heading: "",
      content: "This custom section can only be added once. You can add multiple custom section types to your resume.",
      confirmButtonText: "Proceed to Section",
      cancelButtonText: 'Ok'
    },
  },
  downloadcompletionbox: {
    type: 'confirmbox',
    content: {
      heading: "Don't forget to add a cover letter to go with your resume.",
      content: "Our cover letter tool can help you write the perfect cover letter. Start now!",
      confirmButtonText: "Ok, let's start!",
      cancelButtonText: 'Not yet'
    },
  },
  exit: {
    type: 'confirmbox',
    content: {
      heading: "",
      content: "Are you sure you want to exit?",
      confirmButtonText: "Go to Dashboard",
      cancelButtonText: 'Cancel'
    },
  },
  download: {
    type: "downloadbox",
    content: {
      heading: `Download Resume`,
      content: "",
      confirmButtonText: "Continue",
      cancelButtonText: "Cancel"
    }
  },
  show_profile_picture: {
    type: 'confirmbox',
    content: SHOW_PROFILE_PICTURE_CONFIRMATION_BOX_CONTENT,
  },
  rearrangebox: {
    type: 'rearrangebox',
    content: {
      content: ''
    }
  },
  duplicate: {
    type: 'duplicatebox',
    content: {
      content: ''
    }
  },
  rename: {
    type: 'renamebox',
    content: {
      content: ''
    }
  },
  ai_entity_title: {
    type: 'aientitytitlebox',
    content: {
      content: ''
    }
  },
  alert: {
    type: 'alertbox',
    content: {
      title: "",
      heading: "",
      content: "",
      confirmButtonText: "Ok",
      cancelButtonText: ""
    }
  },
  aiwarning: {
    type: 'alertbox',
    content: {
      title: "Error",
      heading: "Error",
      content: "System is not able to auto generate coverletter. Please try after sometime or write it yourself. We are sorry for inconvenience. ",
      confirmButtonText: "Close",
      cancelButtonText: ""
    }
  },
  wait: {
    type: 'waitingbox',
    content: {
      title: "",
      heading: "",
      content: "Generating your cover letter",
      confirmButtonText: "Ok",
      cancelButtonText: ""
    }
  },
  aiwarning: {
    type: 'confirmbox',
    content: {
      title: "Error",
      heading: "Oops!",
      content: "We're sorry, our system couldn't auto-generate a cover letter. Please try again and contact us for support if the error persists.",
      confirmButtonText: "Regenerate Cover Letter",
      cancelButtonText: "Close"
    }
  },
  cl_content_override: {
    type: 'confirmbox',
    content: {
      title: "Confirm",
      heading: "Overwrite Your Cover Letter?",
      content: "This action will replace your cover letter with new content. Would you like to proceed?",
      confirmButtonText: "Continue",
      cancelButtonText: "Cancel"
    }
  },
  askfor_trustpilot_review: {
    type: 'askforreview',
    content: {
      title: "Thank you for using resume.org!",
      heading: "Thank you for using Resume.org!",
      content: "Congratulations on your new resume! Check your download folder for your file. ",
      confirmButtonText: "Review us on",
      cancelButtonText: ""
    }
  },
}

export const TOOLTIPS = {
  heading: `<h3>Resume.org Pro Tip</h3><p>Include your name, email, phone number, city, and state in the header.</p><ul><li>If you have a LinkedIn profile, you can include a link here too.</li><li>You only need to include your street address for jobs that require it, like federal positions.</li><li>If you have an online portfolio, include the link in this section as well.</li></ul>`,
  work_history: `<h3>Resume.org Pro Tip</h3><p>Include your name, email, phone number, city, and state in the header.</p><ul><li>If you have a LinkedIn profile, you can include a link here too.</li><li>You only need to include your street address for jobs that require it, like federal positions.</li><li>If you have an online portfolio, include the link in this section as well.</li></ul>`,
  education_history: `<h3>Resume.org Pro Tip</h3><p>Include your name, email, phone number, city, and state in the header.</p><ul><li>If you have a LinkedIn profile, you can include a link here too.</li><li>You only need to include your street address for jobs that require it, like federal positions.</li><li>If you have an online portfolio, include the link in this section as well.</li></ul>`,
  skills: "<h3>Resume.org Pro Tip</h3><p>Include your name, email, phone number, city, and state in the header.</p><ul><li>If you have a LinkedIn profile, you can include a link here too.</li><li>You only need to include your street address for jobs that require it, like federal positions.</li><li>If you have an online portfolio, include the link in this section as well.</li></ul>",
  additional_sections: "<h3>Resume.org Pro Tip</h3><p>Include your name, email, phone number, city, and state in the header.</p><ul><li>If you have a LinkedIn profile, you can include a link here too.</li><li>You only need to include your street address for jobs that require it, like federal positions.</li><li>If you have an online portfolio, include the link in this section as well.</li></ul>",
  summary: "<h3>Resume.org Pro Tip</h3><p>Include your name, email, phone number, city, and state in the header.</p><ul><li>If you have a LinkedIn profile, you can include a link here too.</li><li>You only need to include your street address for jobs that require it, like federal positions.</li><li>If you have an online portfolio, include the link in this section as well.</li></ul>",
  cover_editor_content: "<h3>Our Advice</h3><p>Your cover letter should feature five main elements: a heading, salutation, introduction, two body paragraphs, and a closing section.</p><ul><li>Quantify your achievements by using numbers to give context to your experience. Share growth percentages, satisfaction ratings, and key performance indicators. </li><li>Explain why you're drawn to the opportunity. Highlight aspects of the role you're well suited for or what you like about the company.</li><li>Align your cover letter with the job description, tailoring your cover letter to mention specifics about the company and draw attention to aspects of your skills and experience that match the employer's needs.</li></ul>"
}
export const TRANSITIONAL_BLOCKS = {
  work_history: `<ul><li>Quantify your professional achievements with numbers and data.</li><li>Reframe routine job responsibilities as accomplishments.</li></ul>`,
  education_history: `<ul><li>Feature degrees, certifications or licenses, and training related to your industry.</li><li>Recent graduates: highlight academic projects, awards, and coursework.</li></ul>`,
  skills: "<ul><li>Incorporate keywords from job descriptions so employers and applicant tracking systems can scan your resume.</li><li>Highlight a mix of hard skills like programming and soft skills like team management.</li></ul> ",
  summary: "<ul><li>Provide a concise, high-level overview of your professional achievements and strengths.</li><li>Highlight your job title, experience, and key skills.</li></ul> "
}

export const DEFAULT_RB_AI_DATA = [];

export const SECTION_COLOR_CLASS = {
  heading: "blue-line",
  work_history: "red-line",
  education_history: "light-green-line",
  skills: "light-blue-line",
  additional_sections: "orange-line"
};

export const BETATOOLTIP = "<p>We are excited to announce that we have launched the new beta version of our Resume Builder app. For a limited time, we have unlocked all the premium features, providing you with full access to powerful tools that can make your resume truly stand out. The beta version will be available until June 20th, 2023.</p>";

export const SUMMARY_TOOLTIP = "<p>Build your resume using one of the following tools: Our database of suggested phrases written by certified resume writers or our resume builder AI that generates bullet points based on your target role. Alternatively, you can add your own content directly to the resume builder.</p>";
//Template name used in src/components/CreateResumeWithTemplate.jsx also
export const DEFAULT_TEMPLATE_COLOR = {
  'template-one': '#434343',
  'template-one-v2': '#DE8535',
  'template-one-v3': '#DE8535',
  'template-two': '#17A9E4',
  'template-two-v2': '#46818F',
  'template-two-v3': '#FBE5CD',
  'template-three': '#E06665',
  'template-three-v2': '#434343',
  'template-three-v3': '#B2436F',
  'template-three-v4': '#434343',
  'template-three-v5': '#434343',
  'template-four': '#58585B',
  //Template name used in src/components/CreateResumeWithTemplate.jsx also
  'template-four-v2': '#0C5395',
  'template-four-v3': '#434343',
  'template-four-v4': '#434343',
  'template-four-v5': '#A64D79',
  'template-five': '#46818F',
  'template-five-v2': '#674FA7',
  'template-five-v3': '#434343',
  'template-five-v4': '#98C64D',
  'template-five-v5': '#674FA7',
  'template-six': '#434343',
  'template-six-v2': '#5B509B',
  'template-six-v3': '#144F5D',
  'template-seven': '#666666',
  //Template name used in src/components/CreateResumeWithTemplate.jsx also
  'template-seven-v2': '#073863',
  'template-seven-v3': '#8D7CC2',
  'template-eight': '#073863',
  'template-eight-v2': '#144F5D',
  'template-eight-v3': '#46818F',
  'template-nine': '#0D183A',
  'template-nine-v2': '#434343',
  'template-nine-v3': '#0D183A',
  'template-ten': '#E06665',
  'template-ten-v2': '#A64D79',
  'template-ten-v3': '#C7C9F8',
  'template-ten-v4': '#A6005A',
  'template-ten-v5': '#3E85C7',
  //Template name used in src/components/CreateResumeWithTemplate.jsx also
  'template-eleven': '#0E5293',
  'template-twelve': '#CFE2F3',
  'template-thirteen': '#434343',
  'template-fourteen': '#E69137',
  'template-fifteen': '#BC9300',
  'template-sixteen': '#144F5D',
  'template-sixteen-v2': '#000000',
  'template-seventeen': '#A64D79',
  'template-eighteen': '#741B47',
  'template-nineteen': '#0C5395',
  'template-twenty': '#BF9100',
  'template-thirty-seven': '#BF9100',
  'template-thirty-eight': '#45818E',
  'template-thirty-nine': '#45818E',
  'template-twenty-one': '#2A2C27',
  'template-twenty-three': '#144F5D',
  'template-twenty-three-v2': '#785F93',
  'template-twenty-four': '#1C4587',
  'template-twenty-five': '#F5F5F5',
  'template-thirty-one': '#144F5D',
  'template-thirty-two': '#1C4587',
  'template-thirty-three': '#E99D3E',
  'template-thirty-four': '#5B746E',
};
export const DEFAULT_COVERLETTER_TEMPLATE_COLOR = {
 
  //Template name used in src/components/CreateResumeWithTemplate.jsx also
  'template-eleven': '#588981',
  'template-twelve': '#4D5279',
  'template-thirteen': '#E4A829',
  'template-fourteen': '#C34C8C',
  'template-sixteen': '#245610',
  'template-seventeen': '#2F497E',
  'template-eighteen': '#BC936D',
  'template-nineteen': '#0C5395',
  'template-twenty-three': '#618553',
  'template-twenty-four': '#543477',
  'template-sixteen-v2': '#000000',
  'template-twenty-three-v2': '#785F93'
};
//color variant name used in src/components/CreateResumeWithTemplate.jsx also
export const DEFAULT_VARIANT_COLOR = {
  'color-variant-one': '#DE8535',
  'color-variant-two': '#17A9E4',
  'color-variant-three': '#B2436F',
  'color-variant-four': '#58585B',
  'color-variant-five': '#98C64D',
  'color-variant-six': '#5B509B',
  'color-variant-seven': '#DD3B7A',
  'color-variant-eight': '#5E8E66',
  'color-variant-nine': '#0D183A',
  'color-variant-ten': '#000000',
  'color-variant-eleven': '#2A64AD',
  'color-variant-twelve': '#E9932F',
  'color-variant-thirteen': '#E9932F',
  //color variant name used in src/components/CreateResumeWithTemplate.jsx also
  'color-variant-fourteen': '#5B509B',
  'color-variant-fifteen': '#000000',
  'color-variant-sixteen': '#98c64d',
  'color-variant-seventeen': '#2A64AD',
  'color-variant-eighteen': '#E9932F',
  'color-variant-nineteen': '#DD3B7A',
  'color-variant-twenty': '#000000',
  'color-variant-twenty-one': '#2A2C27',
  'color-variant-twenty-five': '#a71b24',
  'color-variant-twenty-three': '#385718',
  'color-variant-twenty-four': '#5b509b',
  'color-variant-sixteen-v2':'#B16BA4',
  'color-variant-thirty-one': '#144F5D',
  'color-variant-thirty-two': '#1C4587',
  'color-variant-thirty-three': '#8D7CC2',
  'color-variant-thirty-four': '#144F5D',
  'color-variant-thirty-five': '#073863',
  'color-variant-thirty-six': '#434343',
  'color-variant-thirty-seven': '#741B47',
  'color-variant-thirty-eight': '#144F5D',
  'color-variant-thirty-nine': '#434343',
  'color-variant-forty': '#E06665',
  'color-variant-forty-one': '#0C5395',
  'color-variant-forty-two': '#BF9100',
  'color-variant-forty-three': '#144F5D',
  'color-variant-forty-four': '#434343',
  'color-variant-forty-five': '#674FA7',
  'color-variant-forty-six': '#073863',
  'color-variant-forty-seven': '#434343',
  'color-variant-forty-eight': '#A64D79',
  'color-variant-forty-nine': '#434343',
  'color-variant-fifty': '#0C5395',
  'color-variant-fifty-one': '#434343',
  'color-variant-fifty-two': '#434343',
  'color-variant-fifty-three': '#434343',
  'color-variant-fifty-four': '#434343',
  'color-variant-fifty-five': '#A64D79',
  'color-variant-fifty-six': '#E69137',
  'color-variant-fifty-seven': '#46818F',
  'color-variant-fifty-eight': '#674FA7',
  'color-variant-fifty-nine': '#434343',
  'color-variant-sixty': '#CFE2F3',
  'color-variant-sixty-one': '#46818F',
  'color-variant-sixty-two': '#E06665',
  'color-variant-sixty-three': '#FBE5CD',
  'color-variant-sixty-four': '#434343',
  'color-variant-sixty-five': '#F5F5F5',
  'color-variant-sixty-six': '#434343',
  'color-variant-sixty-seven': '#46818F',
  'color-variant-sixty-eight': '#0E5293',
  'color-variant-sixty-nine': '#666666',
  'color-variant-seventy': '#BC9300',
  'color-variant-seventy-one': '#C7C9F8',
  'color-variant-seventy-two': '#0000008C',
  'color-variant-seventy-three': '#3E85C7',
  'color-variant-seventy-four': '#A6005A',
  'color-variant-seventy-five': '#674E9D',
  'color-variant-seventy-six': '#A81D1D',
  'color-variant-seventy-seven': '#A64D79',
  //NEW TEMPLATES - #511
  // 'color-variant-thirty-two-2': '#595959',
  // 'color-variant-thirty-three-3': '#E99D3E',
  // 'color-variant-thirty-four-4': '#8C927D',
  // 'color-variant-thirty-five-5': '#474747',
  // 'color-variant-thirty-six-6': '#555D50',
  // 'color-variant-thirty-seven-7': '#5198A8',
  // 'color-variant-thirty-eight-8': '#45818E',
  // 'color-variant-thirty-nine-9': '#666666',
};
//color variant name used in src/components/CreateResumeWithTemplate.jsx also
export const TEMPLATE_IDS = {
  t1v1: {tpl: 'template-one', color: 'color-variant-thirty-six'},
  t1v2: {tpl: 'template-one-v2', color: 'color-variant-one'},
  t1v3: {tpl: 'template-one-v3', color: 'color-variant-one'},
  t2v1: {tpl: 'template-two', color: 'color-variant-two'},
  t2v2: {tpl: 'template-two-v2', color: 'color-variant-fifty-seven'},
  t2v3: {tpl: 'template-two-v3', color: 'color-variant-sixty-three'},
  t3v1: {tpl: 'template-three', color: 'color-variant-forty'},
  t3v2: {tpl: 'template-three-v2', color: 'color-variant-forty-nine'},
  t3v3: {tpl: 'template-three-v3', color: 'color-variant-three'},
  t3v4: {tpl: 'template-three-v4', color: 'color-variant-fifty-two'},
  t3v5: {tpl: 'template-three-v5', color: 'color-variant-sixty-four'},
  t4v1: {tpl: 'template-four', color: 'color-variant-four'},
  t4v2: {tpl: 'template-four-v2', color: 'color-variant-fifty'},
  t4v3: {tpl: 'template-four-v3', color: 'color-variant-fifty-three'},
  t4v4: {tpl: 'template-four-v4', color: 'color-variant-forty-seven'},
  t4v5: {tpl: 'template-four-v5', color: 'color-variant-fifty-five'},
  t5v1: {tpl: 'template-five', color: 'color-variant-sixty-seven'},
  t5v2: {tpl: 'template-five-v2', color: 'color-variant-fifty-eight'},
  t5v3: {tpl: 'template-five-v3', color: 'color-variant-thirty-nine'},
  t5v4: {tpl: 'template-five-v4', color: 'color-variant-five'},
  t5v5: {tpl: 'template-five-v5', color: 'color-variant-forty-five'},
  t6v1: {tpl: 'template-six', color: 'color-variant-forty-four'},
  t6v2: {tpl: 'template-six-v2', color: 'color-variant-seventy-five'},
  t6v3: {tpl: 'template-six-v3', color: 'color-variant-thirty-four'},
  t7v1: {tpl: 'template-seven', color: 'color-variant-sixty-nine'},
  t7v2: {tpl: 'template-seven-v2', color: 'color-variant-forty-six'},
  t7v3: {tpl: 'template-seven-v3', color: 'color-variant-thirty-three'},
  t8v1: {tpl: 'template-eight', color: 'color-variant-thirty-five'},
  t8v2: {tpl: 'template-eight-v2', color: 'color-variant-thirty-eight'},
  t8v3: {tpl: 'template-eight-v3', color: 'color-variant-sixty-one'},
  t9v1: {tpl: 'template-nine', color: 'color-variant-nine'},
  t9v2: {tpl: 'template-nine-v2', color: 'color-variant-fifty-four'},
  t9v3: {tpl: 'template-nine-v3', color: 'color-variant-fifty-nine'},
  t10v1: {tpl: 'template-ten', color: 'color-variant-sixty-two'},
  t10v2: {tpl: 'template-ten-v2', color: 'color-variant-seventy-seven'},
  t10v3: {tpl: 'template-ten-v3', color: 'color-variant-seventy-one'},
  t10v4: {tpl: 'template-ten-v4', color: 'color-variant-seventy-four'},
  t10v5: {tpl: 'template-ten-v5', color: 'color-variant-seventy-three'},
  t11: {tpl: 'template-eleven', color: 'color-variant-sixty-eight'},
  t12: {tpl: 'template-twelve', color: 'color-variant-sixty'},
  t13: {tpl: 'template-thirteen', color: 'color-variant-sixty-six'},
  t14: {tpl: 'template-fourteen', color: 'color-variant-fifty-six'},
  t15: {tpl: 'template-fifteen', color: 'color-variant-seventy'},
  t16: {tpl: 'template-sixteen', color: 'color-variant-thirty-one'},
  // t16v2: {tpl: 'template-sixteen-v2', color: 'color-variant-sixteen'},
  t17: {tpl: 'template-seventeen', color: 'color-variant-forty-eight'},
  t18: {tpl: 'template-eighteen', color: 'color-variant-thirty-seven'},
  t19: {tpl: 'template-nineteen', color: 'color-variant-forty-one'},
  t20: {tpl: 'template-twenty', color: 'color-variant-forty-two'},
  t21: {tpl: 'template-twenty-one', color: 'color-variant-twenty-one'},
  t22: {tpl: 'template-twenty-five', color: 'color-variant-sixty-five'},
  t23: {tpl: 'template-twenty-three', color: 'color-variant-forty-three'},
  t23v2: {tpl: 'template-twenty-three-v2', color: 'color-variant-twenty-three'},
  t24: {tpl: 'template-twenty-four', color: 'color-variant-thirty-two'},
  t31:{tpl:'template-thirty-one',color:'color-variant-thirty-one'},
  // t32:{tpl:'template-thirty-two',color:'color-variant-thirty-two-2'},
  // t33:{tpl:'template-thirty-three',color:'color-variant-thirty-three-3'},
  // t34:{tpl:'template-thirty-four',color:'color-variant-thirty-four-4'},
  // t35:{tpl:'template-thirty-five',color:'color-variant-thirty-five-5'},
  // t36:{tpl:'template-thirty-six',color:'color-variant-thirty-six-6'},
  // t37: { tpl: 'template-thirty-seven', color: 'color-variant-forty-two' },
  // t38: { tpl: 'template-thirty-eight', color: 'color-variant-seventy-seven' },
  // t39: { tpl: 'template-thirty-nine', color: 'color-variant-seventy-seven' },
  // t26: {tpl: 'template-twenty-six', color: 'color-variant-twenty-six'},
}
export const DEFAULT_PLAN = {
  name: "",
  username: "",
  email: "",
  plan:{
      trial_plan: false,
      status: "",
      is_basic: "",
      name: "",
      description: "",
      expiryDate: ""
  }
}

export const PAYMENT_METHOD_TYPES = ['card', 'googlePay', 'applePay']; 

export const DISABLED_RATING_TEMPLATES = [
  'template-one',
  'template-two-v3',
  'template-three-v3',
  'template-four',
  'template-four-v5',
  'template-five',
  'template-five-v5',
  'template-six',
  'template-seven',
  'template-eight-v2',
  'template-nine-v2',
  'template-ten',
  'template-ten-v2',
  'template-ten-v3',
  'template-ten-v4',
  'template-ten-v5',
  'template-thirty-eight',
  'template-thirty-nine',
  'template-twenty-three',
  'template-twenty-five',
  'template-sixteen-v2',
  'template-twenty-six'
];
export const REVIEW_ERROR_TYPES = [
  {
    key: 'capitalization',
    label: 'Capitalization',
  },
  {
    key: 'completeness',
    label: 'Completeness',
  },
  {
    key: 'content_order',
    label: 'Information order',
  },
  {
    key: 'personal_pronouns',
    label: 'Personal pronouns',
  },
  {
    key: 'words_in_bracket',
    label: 'Update placeholder text',
  },
  {
    key: 'quantifiable_results',
    label: 'Quantifiable results',
  },
  {
    key: 'spell_check',
    label: 'Spelling',
  },
  {
    key: 'filler_words',
    label: 'Word usage',
  },
]
export const STRENGTH_LEVEL = {
  l1:{grade: 'Excellent', msg: 'Great!' , desc: 'Your resume is outstanding! Have you done this before?'},
  l2:{grade: 'Good', msg: 'Almost there' , desc: 'Just some small tweaks and your resume will be good to go!'},
  l3:{grade: 'Good', msg: 'Looking good' , desc: 'Your resume is in great shape, but let’s go over a few areas you can improve.'},
  l4:{grade: 'Fair', msg: 'Needs a bit more work' , desc: 'See our suggestions for perfecting your resume.'},
  l5:{grade: 'Poor', msg: 'Let’s work on it' , desc: 'Your resume needs improvement. Check out our suggestions!'}
}
export const SECTION_INFO = {
  personal_details: {label: 'Personal Details', desc: 'Your personal details should offer information an employer can use to reach you for an interview. Include your name, location, email address, phone number, and LinkedIn profile or portfolio.'},
  work_history: {label: 'Professional Experience', desc: 'Employers want to see what you’ve accomplished in previous positions and understand what you can do for their organization. Describe your responsibilities and achievements using specific figures whenever possible.'},
  education_history: {label: 'Education', desc: 'You’ve earned it, so don’t be shy about your educational credentials. Add your educational background, including any institutions you’ve attended and degrees or certifications you’ve earned.'},
  skills: {label: 'Key Skills', desc: 'Highlighting your key skills helps employers know what you’re capable of. Focus on hard skills such as expert knowledge within your field or proficiency with particular programs or tools.'},
  summary: {label: 'Summary', desc: 'Catch a hiring manager’s eye with a compelling summary that features key qualifications the organization is looking for. Focus on phrases from the job description whenever possible.'}
}

export const DAY_TO_UPDATE_YEAR = 5;
export const AI_CHAT_LABEL_MESSAGE = {
  education: {
    0: {
      prompt: "Rewrite my education description",
      staticText: "--copy and paste your summary--",
    },
    1: {
      prompt: "Improve my education description",
      staticText: "--please provide the education information you'd like to update--",
    },
  },
  workhistory: {
    0: {
      prompt: "Rewrite my work summary",
      staticText: "--copy and paste your professional experience--",
    },
    1: {
      prompt: "Improve my work summary",
      staticText: "--please provide the professional experience information you'd like to update--",
    },
  },
  skills: {
    0: {
      prompt: "Rewrite my skills",
      staticText: "--copy and paste your skills--",
    },
    1: {
      prompt: "Improve my skills",
      staticText: "--please provide the skills information you'd like to update--",
    },
  },
  summary: {
      0: {
        prompt: "Rewrite my resume summary",
        staticText: "--copy and paste your resume summary--",
      },
      1: {
        prompt: "Improve my resume summary",
        staticText: "--please provide the summary information you'd like to update--",
      },
    },
  additionalsections: {
      0: {
          prompt: "Rewrite my additional information",
          staticText: "--copy and paste your more information--",
      },
      1: {
          prompt: "Improve my resume additional information",
          staticText: "--please provide the addtioanl information you'd like to update--",
      },
  },
  default: {
    0: {
      prompt: "Rewrite my summary",
      staticText: "--copy and paste your summary--",
    },
    1: {
      prompt: "Improve my resume",
      staticText: "--please provide the summary information you'd like to update--",
    },
  },
};
